import { ParentAttributeListUrlSortField } from "@dashboard/parentAttributes/urls";
import { PLACEHOLDER } from "@dashboard/components/Datagrid/const";
import { readonlyTextCell } from "@dashboard/components/Datagrid/customCells/cells";
import { AvailableColumn } from "@dashboard/components/Datagrid/types";
import { Sort } from "@dashboard/types";
import { getColumnSortDirectionIcon } from "@dashboard/utils/columns/getColumnSortDirectionIcon";
import { GridCell, Item } from "@glideapps/glide-data-grid";
import { IntlShape } from "react-intl";
import { columnsMessages } from "./messages";
import { ParentAttribute } from "../../types";

export const parentAttributesListStaticColumnsAdapter = (
  intl: IntlShape,
  sort: Sort<ParentAttributeListUrlSortField>,
) =>
  [
    {
      id: "slug",
      title: intl.formatMessage(columnsMessages.slug),
      width: 300,
    },
    {
      id: "name",
      title: intl.formatMessage(columnsMessages.name),
      width: 300,
    },
    {
      id: "children",
      title: intl.formatMessage(columnsMessages.children),
      width: 400,
    },
  ].map(column => ({
    ...column,
    icon: getColumnSortDirectionIcon(sort, column.id),
  }));

export const createGetCellContent =
  ({
    parentAttributes,
    columns,
    intl,
  }: {
    parentAttributes: ParentAttribute[];
    columns: AvailableColumn[];
    intl: IntlShape;
  }) =>
  ([column, row]: Item): GridCell => {
    const rowData: ParentAttribute | undefined = parentAttributes[row];
    const columnId = columns[column]?.id;

    if (!columnId || !rowData) {
      return readonlyTextCell("");
    }

    switch (columnId) {
      case "slug":
        return readonlyTextCell(rowData?.slug ?? PLACEHOLDER);
      case "name":
        return readonlyTextCell(rowData?.name ?? PLACEHOLDER);
      case "children":
        const childrenNames = rowData?.children?.map(c => c.name).join(", ") || "-";
        return readonlyTextCell(childrenNames);
      default:
        return readonlyTextCell("");
    }
  };